import { formatCurrency } from '@lib/utils/formatCurrency'
import cn from 'classnames'
import s from './GiftCardProductPrice.module.scss'
import type { ReactElement } from 'react'
export type GiftCardProductPrice = {
    className?: string
    minimum_price?: number | undefined
    maximum_price?: number
}
export const GiftCardProductPrice = ({
    className,
    minimum_price = 0,
    maximum_price = 0
}: GiftCardProductPrice): ReactElement => {
    const minSubtotalCurrency = formatCurrency(minimum_price)
    const maxPriceCurrency = maximum_price ? formatCurrency(maximum_price) : ''
    return (
        <div
            className={cn(['product-price', className])}
            tabIndex={0}
            role="button"
        >
            <span className={cn(s['subtotal-price'])}>
                {minSubtotalCurrency}{' '}
                {maxPriceCurrency ? `- ${maxPriceCurrency}` : null}
            </span>
        </div>
    )
}
